import { Record } from 'immutable'


const SyncItem = Record({
  id:null,
  target_name: null,
});
export default SyncItem;
